export const extractRouteParamsFromLocation = (nextJsUrl: string) => {
  const match = nextJsUrl.match(/\[.*?]/);
  return !!match ? location.pathname : nextJsUrl;
};
